export const WarehouseNameFilterData = [
    {
        "idFromColumnFilter": "address",
        "id": "address",
        "filterFn": (value, filterValue) => {
            const address = value ? `${value?.locality} ${value?.street} ${value?.houseNumber}` : ""
            return address?.toLowerCase().includes(filterValue.toLowerCase())
        }
    },
    {
        "idFromColumnFilter": "name",
        "id": "name",
    },
]